import Footer from "../Components/Footer/Footer";
import Navbar from "../Components/Navbar/Navbar";

const Layout = ({ children }) => {
  return (
    <div className="h-full w-full">
      <Navbar />
      {children}
      <Footer />
    </div>
  );
};
export default Layout;
